document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".collection-card__inner");

  window.cardObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("zoom-active");
        else e.target.classList.remove("zoom-active");
      });
    },
    { threshold: 0.4 },
  );

  cards.forEach((card) => window.cardObserver.observe(card));

  // Product Finder Pop Up
  const popupWrapper = document.querySelector(".product_finder_popup_wrapper");
  const popupBox = document.querySelector(".product_finder_popup");
  const closeBtn = document.querySelector(".popup_close_button");
  const homePageBanner = document.querySelector(".home-page-banner");
  const bannerButton = homePageBanner?.querySelector(".button-secondary");
  bannerButton?.classList.add("open_pop_up_button");
  const openPopupButtons = document.querySelectorAll(".open_pop_up_button");

  openPopupButtons?.forEach((openPopupButton) => {
    openPopupButton.addEventListener("click", (e) => {
      e.preventDefault();
      popupWrapper?.classList.add("pop_up_active");
      document.body.style.overflow = "hidden";
    });
  });

  closeBtn?.addEventListener("click", () => {
    popupWrapper?.classList.remove("pop_up_active");
    document.body.style.overflow = "auto";
  });

  popupWrapper?.addEventListener("click", (e) => {
    if (popupBox && !popupBox.contains(e.target)) {
      popupWrapper.classList.remove("pop_up_active");
      document.body.style.overflow = "auto";
    }
  });

  // Drawer Open and Close JS
  let customDrawerWrapper = document.querySelector(".custom_drawer_wrapper");
  let customDrawer = document.querySelector(".custom_drawer");
  let drawerOpenButton = document.querySelector(".browse-all-categories");
  let drawerCloseButton = document.querySelector(".custom_drawer_close_button");

  drawerOpenButton?.addEventListener("click", (e) => {
    e.preventDefault();
    customDrawerWrapper?.classList.add("custom_drawer_wrapper_active");
    customDrawer?.classList.add("custom_drawer_active");
    document.body.style.overflow = "hidden";
  });

  drawerCloseButton?.addEventListener("click", (e) => {
    e.preventDefault();
    customDrawerWrapper?.classList.remove("custom_drawer_wrapper_active");
    customDrawer?.classList.remove("custom_drawer_active");
    document.body.style.overflow = "auto";
  });

  customDrawerWrapper?.addEventListener("click", (e) => {
    if (customDrawer && !customDrawer.contains(e.target)) {
      customDrawerWrapper?.classList.remove("custom_drawer_wrapper_active");
      customDrawer?.classList.remove("custom_drawer_active");
      document.body.style.overflow = "auto";
    }
  });

  // Product Description
  let descriptionWrapper = document.querySelector(".description_wrapper");
  let descriptionBtn = descriptionWrapper?.querySelector(".description-btn");
  let additionalInfoBtn = descriptionWrapper?.querySelector(
    ".additional-info-btn",
  );

  let otherInfoBtn = descriptionWrapper?.querySelector(".other-info-btn");

  let productDescription = descriptionWrapper?.querySelector(
    ".product-description",
  );

  let additionInformation = descriptionWrapper?.querySelector(
    ".product_additional_information",
  );

  let otherInformation = descriptionWrapper?.querySelector(
    ".product-other-info",
  );

  additionalInfoBtn?.addEventListener("click", (e) => {
    additionInformation?.classList.add("active");
    productDescription?.classList.add("deactive");
    otherInformation?.classList.remove("active");

    additionalInfoBtn?.classList.add("button-secondary");
    descriptionBtn?.classList.remove("button-secondary");
    otherInfoBtn?.classList.remove("button-secondary");
  });

  descriptionBtn?.addEventListener("click", (e) => {
    additionInformation?.classList.remove("active");
    productDescription?.classList.remove("deactive");
    otherInformation?.classList.remove("active");

    additionalInfoBtn?.classList.remove("button-secondary");
    descriptionBtn?.classList.add("button-secondary");
    otherInfoBtn?.classList.remove("button-secondary");
  });

  otherInfoBtn?.addEventListener("click", (e) => {
    additionInformation?.classList.remove("active");
    productDescription?.classList.add("deactive");
    otherInformation?.classList.add("active");

    additionalInfoBtn?.classList.remove("button-secondary");
    descriptionBtn?.classList.remove("button-secondary");
    otherInfoBtn?.classList.add("button-secondary");
  });

  // Cart Drawer Slider
  setTimeout(() => {
    const sliderWrapper = document.querySelector(".cart-reco-slider");
    const slidesWrapper = sliderWrapper?.querySelector(".cart-reco-wrapper");
    const cardSlides = slidesWrapper?.querySelectorAll(".resource-list__item");
    const dotsWrapper = sliderWrapper?.querySelector(".dots-wrapper");

    const cardsPerSlide = 2;
    const gap = 10; // gap in px between slides
    const totalSlides = Math.ceil(cardSlides.length / cardsPerSlide);

    // Create dots
    for (let i = 0; i < totalSlides; i++) {
      let dotBtn = document.createElement("button");
      dotBtn.classList.add("dot-button");
      if (i === 0) dotBtn.classList.add("active-dot");
      dotsWrapper?.appendChild(dotBtn);
    }

    const sliderDots = dotsWrapper?.querySelectorAll(".dot-button");

    // Dot click logic
    sliderDots?.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        sliderDots.forEach((d) => d.classList.remove("active-dot"));
        dot.classList.add("active-dot");

        // Calculate movement
        const moveX = -(index * 100) + "%";

        if (slidesWrapper) {
          slidesWrapper.style.transform = `translateX(${moveX})`;
        }
      });
    });
  }, 2000);
});